// extracted by mini-css-extract-plugin
export default {"root":"MenuAction_root__Ub8A3","destructive":"MenuAction_destructive__Rju0o","icon":"MenuAction_icon__u1u3W","iconSpace":"MenuAction_iconSpace__wYF1a"};